import Vue from 'vue';
import matches from 'lodash.matches';

const DEFAULT_TIME_TO_LIVE = 60 * 60 * 1e3;
const stateDataIsStillValid = (expiresAt) => {
  const currentTime = new Date().getTime();
  return currentTime < expiresAt;
};
const getMdg2EndpointData = () => (state) => (payload) => {
  var _a;
  return (_a = state[JSON.stringify(payload)]) == null ? void 0 : _a.result;
};
const setMdg2EndpointData = () => (state, payload) => {
  if (state[payload.key]) {
    state[payload.key] = Object.freeze(payload.data);
  } else {
    Vue.set(state, payload.key, Object.freeze(payload.data));
  }
};
const fetchMdg2EndpointData = (request, mdg2Client, logger) => async (store, payload) => {
  var _a, _b, _c, _d, _e;
  const key = JSON.stringify(payload);
  const ttl = (_a = request.ttl) != null ? _a : DEFAULT_TIME_TO_LIVE;
  const expiresAt = (_b = store.state[key]) == null ? void 0 : _b.expiresAt;
  let status = true;
  try {
    if (((_c = store.state[key]) == null ? void 0 : _c.result) != null && expiresAt && stateDataIsStillValid(expiresAt)) {
      return true;
    }
    const url = typeof request.url === "function" ? request.url(payload) : request.url;
    const parameters = request.payloadFormatter ? request.payloadFormatter(payload) : payload;
    logger.debug({
      mdg2Request: {
        type: request.method,
        url,
        payload: parameters
      }
    });
    const result = await mdg2Client.requestEndpoint(request.method, url, parameters, request.options);
    const statusCode = (_e = (_d = result.response.meta) == null ? void 0 : _d.status) == null ? void 0 : _e.code;
    if (!statusCode || statusCode < 200 || statusCode > 299) {
      throw new Error("Mdg2 request failed.");
    }
    store.commit("setEndpointData", {
      key,
      data: {
        result: { data: result.response.data, meta: result.response.meta },
        expiresAt: new Date().getTime() + ttl
      }
    });
  } catch (error) {
    logger.error(error);
    store.commit("setEndpointData", { key, data: { result: null, expiresAt: 0 } });
    status = false;
  }
  return Promise.resolve(status);
};
const refreshMdg2StateAction = () => async (store, payload) => {
  const dirtyCacheKeys = Object.keys(store.state).map((cacheKey) => JSON.parse(cacheKey)).filter(matches(payload));
  await Promise.all(dirtyCacheKeys.map(async (cacheKey) => store.dispatch("fetchEndpointData", cacheKey)));
  return dirtyCacheKeys.map((cacheKey) => JSON.stringify(cacheKey));
};
const baseMdg2EndpointModule = (request, mdg2Client, logger) => ({
  namespaced: true,
  state: {},
  getters: {
    getEndpointData: getMdg2EndpointData()
  },
  mutations: {
    setEndpointData: setMdg2EndpointData()
  },
  actions: {
    fetchEndpointData: fetchMdg2EndpointData(request, mdg2Client, logger),
    refreshState: refreshMdg2StateAction()
  }
});

export { baseMdg2EndpointModule, fetchMdg2EndpointData, getMdg2EndpointData, refreshMdg2StateAction, setMdg2EndpointData, stateDataIsStillValid };
